import { createStore } from 'redux';
import moment from 'moment';
import { User } from './types/user';
import { DefaultRootState } from 'react-redux';
import { controlPlanItem, optionType } from './types/control-plan';
import { SummaryType } from './seomapitype';
import { TenantItem } from './types/tenant';
export interface ApplicationState extends DefaultRootState {
  spinner: boolean;
  sidebarShow: boolean | '' | 'responsive' | undefined;
  cognitoUser: User | null;
  controlPlan: controlPlanItem[];
  filterForm: {
    eq_group_name: string;
  };
  uploadFile: File[];
  eqGroupList: optionType[];
  unitSelection: string;
  controlGroupValue: string;
  modalChartTargetTimestampFrom: number;
  modalChartTargetTimestampTo: number;
  downloadCsvStatus: {
    executionArn: string;
    status?: string;
    responseBody: string;
  };
  tenant_id: string;
  tenantsInfo: TenantItem[];
  msgModal: {
    show: boolean;
    textMsg: string;
  };
}
export const initialState = {
  spinner: false,
  sidebarShow: 'responsive',
  cognitoUser: null,
  controlPlan: [],
  filterForm: {
    eq_group_name: '',
  },
  uploadFile: [],
  eqGroupList: [],
  controlGroupValue: '',
  unitSelection: SummaryType.DAY_30MIN,
  modalChartTargetTimestampFrom: moment().startOf('day').unix(),
  modalChartTargetTimestampTo: moment().startOf('day').unix(),
  downloadCsvStatus: {
    executionArn: '',
    status: '',
    responseBody: '',
  },
  tenant_id: '',
  tenantsInfo: [],
  msgModal: {
    show: false,
    textMsg: '',
  },
};

const changeState = (state = initialState, { type, ...rest }: Record<string, any>) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest };
    case 'clear':
      return initialState;
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
